export default __webpack_public_path__ + "static/media/background-login.c8bcdac6.png";